var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxFolderOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.431V3.54647C2.5 3.32205 2.58915 3.10683 2.74783 2.94814C2.90652 2.78946 3.12174 2.70031 3.34615 2.70031H6.46846C6.66175 2.69468 6.85114 2.75542 7.0051 2.87243C7.15905 2.98944 7.26829 3.15565 7.31462 3.34339L7.57692 4.39262H12.6538C12.8782 4.39262 13.0935 4.48176 13.2522 4.64045C13.4108 4.79914 13.5 5.01436 13.5 5.23877V12.431C13.5 12.6555 13.4108 12.8707 13.2522 13.0294C13.0935 13.1881 12.8782 13.2772 12.6538 13.2772H3.34615C3.12174 13.2772 2.90652 13.1881 2.74783 13.0294C2.58915 12.8707 2.5 12.6555 2.5 12.431Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxFolderOutline);
export default __webpack_public_path__ + "static/media/icon_16px_folder_outline.d581ef4a60cc211b817a0174721a6d64.svg";
export { ForwardRef as ReactComponent };